import ICONS from "../../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import globalText from "../../../../../utils/globalText";
import { globalTextFormat } from "../../../../../utils/globalTextFormat";
import CommonLayout from "../../../../_utils/CommonLayout";
import CommonDestinationAccount from "../../../../_utils/TransactionCommonComponents/CommonDestinationAccount";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import NameFieldCard from "../../../../_utils/TransactionCommonComponents/NameFieldCard";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const ScheduleTransactionStepSelectAccount = ({
  txnPayLoad,
  setTxnPayLoad,
  openOwner,
  setOpenOwner,
  handleOwnerSelection,
  handleOpenDestinationAccountPopup,
  isConfidential,
  setIsConfidential,
}) => {
  return (
    <>
      <div className="max-w-tab-width-normal w-width-full mx-auto py-padding-md px-padding-md Qlg:px-padding-base">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              modalOpen={openOwner}
              setModalOpen={setOpenOwner}
              txnPayLoad={txnPayLoad}
              setTxnPayLoad={setTxnPayLoad}
              shouldShowAssociatedAccounts={false}
              handleOnAccountSelection={handleOwnerSelection}
            />
          </div>

          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <CommonDestinationAccount
              transactionPayload={txnPayLoad}
              setTransactionPayload={setTxnPayLoad}
              onSelectAccount={handleOpenDestinationAccountPopup}
              showAssociatedAccounts={false}
              requiresSourceAccount
              showCreateAccount={true}
              createAccountButtonText={globalText?.REGISTER_NEW_ACCOUNT}
              registerRoute="/beneficiary_account_dashboard/create_beneficiary_account"
              showsBalance={false}
            />
          </div>

          <div className="flex flex-col gap-gap-md w-width-full lg:max-w-[var(--create-box-width)]">
            <NameFieldCard
              title={globalTextFormat(globalText?.SCHEDULE_NAME, [0, 1])}
              placeholder={globalText?.NAME}
              note={globalText?.SCHEDULE_NOTE_MIN_LENGTH}
              fieldName="schedule_name"
              minLength={GlobalConfiguration?.lengthCheckFive}
              mode="strict"
              value={txnPayLoad?.scheduleName}
              onChange={(val) =>
                setTxnPayLoad((prev) => ({ ...prev, scheduleName: val }))
              }
            />

            <ConfidentialCard
              icon={ICONS?.CONFIDENTIAL_TRANSACTION}
              title={globalText?.CREATE_AS_CONFIDENTIAL}
              note={globalText?.CONFIDENTIAL_SCHEDULE_TRANSACTION_NOTE}
              toggleState={isConfidential}
              onToggle={() => setIsConfidential(!isConfidential)}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default ScheduleTransactionStepSelectAccount;
